import React from "react";

import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
// import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import CardContent from "@material-ui/core/CardContent";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  main: {
    "&:last-child": {
      paddingBottom: 0
    }
  },
  cardsText: {
    color: "rgba(255, 255, 255, 0.5)",
    fontFamily: "Roboto",
    fontSize: "12px",
    marginTop: "15px"
  },
  cardsTextFloat: {
    color: "rgba(255, 255, 255, 0.5)",
    float: "right"
  },
  cardTitle: {
    color: "rgb(255, 255, 255)",
    fontSize: "22px",
    fontWeight: "900",
    letterSpacing: "2px"
  }
});

const DataCards = ({ spotterName, spotterTime, spotterTrack }) => {
  const classes = useStyles();

  return (
    <CardContent classes={{ root: classes.main }}>
      <Typography variant="h2" className={classes.cardTitle}>
        {spotterName}
        <div className={classes.cardsTextFloat}>
          {/* <BookmarkBorderIcon /> */}
          <MoreVertIcon />
        </div>
      </Typography>
      <Typography variant="h2" className={classes.cardsText}>
        <AccessTimeIcon
          style={{
            fontSize: "inherit",
            paddingRight: "2px",
            transform: "translate(0, 2px)"
          }}
        />
        {-moment(spotterTime).diff(moment(), "minutes")} min ago
        <div className={classes.cardsTextFloat}>
          <LocationOnIcon
            style={{ fontSize: "inherit", transform: "translate(0, 2px)" }}
          />
          {spotterTrack[0] < -180 ? (
            <React.Fragment>
              {spotterTrack[1].toFixed(2)}°,{" "}
              {(spotterTrack[0] + 360).toFixed(2)}°
            </React.Fragment>
          ) : (
            <React.Fragment>
              {spotterTrack[1].toFixed(2)}°, {spotterTrack[0].toFixed(2)}°
            </React.Fragment>
          )}
        </div>
      </Typography>
    </CardContent>
  );
};

export default DataCards;
